// shared/providers/ThemeWrapper.tsx
import React from "react";
import {StyledEngineProvider} from "@mui/material/styles";
import {CssBaseline as MuiCssBaseline, ThemeProvider as MuiThemeProvider} from "@mui/material";
import {CssVarsProvider as JoyCssVarsProvider, extendTheme as extendJoyTheme, THEME_ID} from "@mui/joy/styles";
import {CssBaseline as JoyCssBaseline} from "@mui/joy";
import '@fontsource/inter'

import {defPrimaryMaterial} from "@shared/Themes";
import {GlobalStyles} from "@mui/styled-engine-sc"; // seu theme MUI
// se quiser customizar tokens do Joy, importe aqui ou deixe vazio para o default
declare module '@mui/joy/styles' {
    interface Palette {
        info: { 100: string, 500: string, 700: string };
        secondary: { 100: string, 500: string, 700: string };
    }
}


const joyTheme = extendJoyTheme({
    colorSchemes: {
        light: {
            palette: {
                primary: {
                    100: '#eef2ff',
                    500: '#8661c5',
                    700: '#482880',
                },
                secondary: {
                    100: '#f3e5f5',
                    500: '#f66835',
                    700: '#aa4802',
                },
                info: {
                    100: '#e3f2fd',
                    500: '#2196f3',
                    700: '#0d47a1',
                },
            },
        },
        dark: {
            palette: {
                primary: {
                    100: '#eef2ff',
                    500: '#8661c5',
                    700: '#482880',
                },
                secondary: {
                    100: '#f3e5f5',
                    500: '#f66835',
                    700: '#aa4802',
                },
                info: {
                    100: '#e3f2fd',
                    500: '#2196f3',
                    700: '#0d47a1',
                },
            },
        }
    },
    // Mapeando o borderRadius
    radius: {
        sm: '0.rem', // Valor similar ao seu 0.5
    },
    components: {
        JoyButton: {
            styleOverrides: {
                root: ({theme}) => ({
                    borderRadius: theme.vars.radius.sm,
                }),
            },
        },
        JoyIconButton: {
            styleOverrides: {
                root: ({theme}) => ({
                    borderRadius: theme.vars.radius.sm,
                }),
            },
        },
        JoyStep: {
            defaultProps: {
                orientation: 'vertical'
            }
        },
    },
    /*fontFamily: {
        body: '"Roboto", "Helvetica", "Arial", sans-serif',
        display: '"Roboto", "Helvetica", "Arial", sans-serif',
        code: '"Roboto Mono", "Courier New", monospace',
    }*/
});


// IMPORTANTE: A função `defPrimaryMaterial` deve agora retornar um tema criado com `extendTheme` do Material-UI,
// não `createTheme`, para gerar as variáveis CSS necessárias.
const muiTheme = defPrimaryMaterial();

export const MaterialProvider: React.FC<{ children: React.ReactNode }> = ({children}) => (
    <StyledEngineProvider injectFirst>
        {/* 1) Material UI - usando CssVarsProvider para melhor interoperabilidade */}
        <MuiThemeProvider theme={muiTheme} modeStorageKey={'aegis_theme'} defaultMode={'dark'}>
            <MuiCssBaseline enableColorScheme/>
            {/* 2) Joy UI - aninhado e com THEME_ID para evitar conflitos de variáveis CSS */}
            <JoyCssVarsProvider theme={{[THEME_ID]: joyTheme}} modeStorageKey={'aegis_theme'} defaultMode={'dark'}>
                <JoyCssBaseline/>
                {children}
                <GlobalStyles styles={{
                    body: {
                        margin: 0,
                        padding: 0,
                        boxSizing: 'border-box',
                        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
                    },
                }}/>
            </JoyCssVarsProvider>
        </MuiThemeProvider>
    </StyledEngineProvider>
);
